import { createTheme } from "@mui/material";

const GuidanceTableTheme = createTheme({
  components: {
    MuiTable: {
      defaultProps: {
        size: "small",
        "aria-label": "a dense table",
      },
      styleOverrides: {
        root: {
          border: "2px solid #D9D9D9",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "inherit",
          fontWeight: "inherit",
          padding: "5px 8px",
          borderWidth: 0,
          "&.reportHeader": {
            textAlign: "center",
            color: "#005CA6",
            fontSize: "1.1em",
            backgroundColor: "#d9d9d9",
            border: "2px solid #F7F7F7",
          },
          "&.reportRowHeader": {
            paddingLeft: 5,
            color: "#383838",
            fontWeight: 500,
            fontSize: ".9em",
            backgroundColor: "#d9d9d9",
            border: "2px solid #F7F7F7",
          },
          "&.reportRow": {
            textAlign: "center",
            color: "#000000",
            fontSize: ".9em",
            backgroundColor: "#d9d9d9",
            border: "2px solid #F7F7F7",
          },
          "&.columnHeader": {
            textAlign: "center",
            color: "#005CA6",
            fontSize: "1.1em",
          },
          "&.rowHeader": {
            paddingLeft: 5,

            color: "#383838",
            fontWeight: 500,
            fontSize: ".9em",
          },
          "&.rowValue": {
            width: 40,
            minWidth: 40,
            textAlign: "center",
            color: "#000000",
            fontSize: ".9em",
          },
          "&.currentCell": {
            backgroundColor: "#F7F7F7",
            borderLeft: "2px solid #D9D9D9",
            borderBottom: "2px solid #D9D9D9",
          },
          "&.pastCell": {
            backgroundColor: "#D9D9D9",
            borderLeft: "2px solid white",
            borderBottom: "2px solid white",
          },
          "&.pastCellLast": {
            backgroundColor: "#D9D9D9",
            borderLeft: "2px solid white",
          },
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#148DD3",
          color: "white",
          fontSize: 12,
          padding: 10,
          // textAlign: "center",
        },
      },
    },
  },
});

export default GuidanceTableTheme;
